import React from 'react';
import {
  Mail, Phone, UserPlus, Building2, MapPin, Briefcase,
  Megaphone, Users, TrendingUp, Activity, Mic,
} from 'lucide-react';
import {
  CardActionButton,
  EntityAvatar,
  InsightChip,
  LeadCardShell,
  MetaDot,
} from './LeadCardShell';

// Per-insight icon mapping. Keep additive; unknown labels use the shared fallback.
const INSIGHT_ICONS = {
  'Frequent poster':    Megaphone,
  'Many followers':     Users,
  'Recent promotion':   TrendingUp,
  'Active on LinkedIn': Activity,
  'Conference speaker': Mic,
};

export default function PersonCard({ person, onFindEmail, onFindPhone, onAddToCRM, imageUrl }) {
  return (
    <LeadCardShell
      actions={(
        <>
          <CardActionButton
            icon={Mail}
            onClick={() => onFindEmail?.(person)}
          >
            Email
          </CardActionButton>
          <CardActionButton
            icon={Phone}
            onClick={() => onFindPhone?.(person)}
          >
            Phone
          </CardActionButton>
          <CardActionButton
            icon={UserPlus}
            onClick={() => onAddToCRM?.(person)}
            title="Add to CRM"
            ariaLabel="Add to CRM"
            flex={false}
            compact
          />
        </>
      )}
    >
      {/* Header: avatar + name + role */}
      <div className="flex items-start gap-3.5">
        <EntityAvatar
          name={person.name}
          initials={person.initials}
          colorClass={person.avatarColor}
          imageUrl={imageUrl}
        />
        <div className="min-w-0 flex-1 pt-0.5">
          <div className="font-semibold text-[15px] tracking-tight text-gray-900 dark:text-white truncate">
            {person.name}
          </div>
          <div className="text-[13px] text-gray-500 dark:text-gray-400 truncate mt-0.5 flex items-center gap-1">
            <Briefcase className="w-3 h-3 text-gray-400 flex-shrink-0" strokeWidth={1.75} />
            <span className="truncate">{person.role}</span>
          </div>
        </div>
      </div>

      <div className="mt-3 flex items-center gap-1.5 text-[12px] text-gray-500 dark:text-gray-400 overflow-hidden">
        <Building2 className="w-3 h-3 flex-shrink-0 text-gray-400" strokeWidth={1.75} />
        <span className="truncate text-gray-700 dark:text-gray-200 font-medium">{person.company}</span>
        {person.country && (
          <>
            <MetaDot />
            <MapPin className="w-3 h-3 flex-shrink-0 text-gray-400" strokeWidth={1.75} />
            <span className="truncate">{person.country}</span>
          </>
        )}
      </div>

      {person.previousCompanies && person.previousCompanies.length > 0 && (
        <div className="mt-3 flex items-baseline gap-1.5 text-[12px] min-w-0">
          <span className="text-gray-400 dark:text-gray-500 flex-shrink-0">Previously</span>
          <span className="text-gray-600 dark:text-gray-300 truncate">
            {person.previousCompanies.join(' · ')}
          </span>
        </div>
      )}

      {person.insights && person.insights.length > 0 && (
        <div className="mt-4 flex flex-wrap gap-1.5">
          {person.insights.map((i, index) => (
            <InsightChip key={`${i}-${index}`} label={i} iconMap={INSIGHT_ICONS} />
          ))}
        </div>
      )}
    </LeadCardShell>
  );
}
